import { FormEvent, useState } from "react";
import { router, Head } from "@inertiajs/react";
import GuestLayout from "@/layouts/GuestLayout";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

interface ResetPasswordProps {
  reset_password_token: string;
  errors?: {
    password?: string;
    password_confirmation?: string;
    reset_password_token?: string;
  };
  minimum_password_length?: number;
}

export default function ResetPassword({
  reset_password_token,
  errors = {},
  minimum_password_length = 6,
}: ResetPasswordProps) {
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);

    router.put(
      "/users/password",
      {
        user: {
          reset_password_token,
          password,
          password_confirmation: passwordConfirmation,
        },
      },
      {
        onFinish: () => setLoading(false),
      }
    );
  };

  return (
    <GuestLayout>
      <Head title="إعادة تعيين كلمة المرور" />
      <Card>
        <CardHeader className="space-y-1">
          <CardTitle className="text-2xl text-center">إعادة تعيين كلمة المرور</CardTitle>
          <CardDescription className="text-center">أدخل كلمة مرور جديدة لحسابك</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            {errors.reset_password_token && (
              <div className="bg-destructive/10 border border-destructive/20 rounded-md p-3">
                <p className="text-sm text-destructive">{errors.reset_password_token}</p>
              </div>
            )}

            <div className="space-y-2">
              <Label htmlFor="password">
                كلمة المرور الجديدة
                <span className="text-xs text-muted-foreground mr-1">
                  ({minimum_password_length} أحرف على الأقل)
                </span>
              </Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="new-password"
                autoFocus
                minLength={minimum_password_length}
              />
              {errors.password && <p className="text-sm text-destructive">{errors.password}</p>}
            </div>

            <div className="space-y-2">
              <Label htmlFor="password_confirmation">تأكيد كلمة المرور</Label>
              <Input
                id="password_confirmation"
                type="password"
                value={passwordConfirmation}
                onChange={(e) => setPasswordConfirmation(e.target.value)}
                required
                autoComplete="new-password"
              />
              {errors.password_confirmation && (
                <p className="text-sm text-destructive">{errors.password_confirmation}</p>
              )}
            </div>

            <Button type="submit" className="w-full" disabled={loading}>
              {loading ? "جاري تغيير كلمة المرور..." : "تغيير كلمة المرور"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </GuestLayout>
  );
}
